import { render, staticRenderFns } from "./PaySadad.vue?vue&type=template&id=61d09ca4&scoped=true"
import script from "./PaySadad.vue?vue&type=script&lang=ts"
export * from "./PaySadad.vue?vue&type=script&lang=ts"
import style0 from "./PaySadad.vue?vue&type=style&index=0&id=61d09ca4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d09ca4",
  null
  
)

export default component.exports